export const getBadRequestDetail = (errorBody: unknown): string | null => {
  if (!errorBody || typeof errorBody !== 'object') return null;

  const body = errorBody as Record<string, unknown>;
  const rawMessages = body['messages'];
  if (Array.isArray(rawMessages)) {
    return rawMessages.filter(Boolean).join('; ');
  }
  if (typeof rawMessages === 'string') {
    return rawMessages;
  }
  if (typeof body['message'] === 'string') {
    return body['message'];
  }

  const modelStateBody =
    body['errors'] && typeof body['errors'] === 'object' ? (body['errors'] as Record<string, unknown>) : body;

  const modelStateMessages = Object.values(modelStateBody)
    .flatMap(value => (Array.isArray(value) ? value : []))
    .filter((value): value is string => typeof value === 'string' && value.length > 0);

  return modelStateMessages.length ? modelStateMessages.join('; ') : null;
};
